import clsx from 'clsx'

interface SpinnerProps {
    className?: string
    height?: number
    width?: number
}

export default function Spinner({ className, height = 3, width =3 }: SpinnerProps) {
    return (
        <div className={clsx("bg-transparent flex justify-center items-center", className)}>
            <div 
                className="animate-spin rounded-full border-b-2 border-secondary-foreground"
                style={{height: `${height}rem`, width: `${width}rem`}}
            />
        </div>
    );
};
